import { render } from "./RecipeRating.vue?vue&type=template&id=7d06d117&scoped=true"
import script from "./RecipeRating.vue?vue&type=script&lang=js"
export * from "./RecipeRating.vue?vue&type=script&lang=js"

import "./RecipeRating.vue?vue&type=style&index=0&id=7d06d117&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d06d117"]])

export default __exports__